import { render, staticRenderFns } from "./outOfStockMgtSelfDelivery.vue?vue&type=template&id=69666727&scoped=true"
import script from "./outOfStockMgtSelfDelivery.vue?vue&type=script&lang=js"
export * from "./outOfStockMgtSelfDelivery.vue?vue&type=script&lang=js"
import style0 from "./outOfStockMgtSelfDelivery.vue?vue&type=style&index=0&id=69666727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69666727",
  null
  
)

export default component.exports